import LocalizedStrings from "react-localization";

const langs = {
  //English LCID
  "1033": {
    ChildhoodObesityToolActvityTracker:
      "Childhood Obesity Tool – Activity Tracker",
    AddFamilyMember: "Add family member",
    About: "About this tool",
    EnterYourName: "Enter your name",
    TypeInTheNameOfAnActivity: "Type in the name of an activity",
    AddMoreActivities: "Add more activities",
    Activity: "Activity",
    Duration: "Duration",
    Intensity: "Intensity",
    Mins: "Mins",
    DeleteStopwatch: "Click to delete this stopwatch and all activities",
    DeleteActivity: "Click to delete activity",
    Swimming: "Swimming",
    Biking: "Biking",
    Hiking: "Hiking",
    Running: "Running",
    Walking: "Walking",
    BurningCalories: "Burning Calories",
    Chess: "Chess",
    Weights: "Weights",
    Basketball: "Basketball",
    Futbol: "Futbol",
    FootballAmerican: "Football (American)",
    Volleyball: "Volleyball",
    PingPong: "Ping Pong",
    Beach: "Beach Exercise",
    Yes: "Yes",
    No: "No",
    HighIntensity: "High Intensity",
    LowIntensity: "Low Intensity",
    ConfirmStopwatchDelete: "Confirm Stopwatch deletion",
    ConfirmStopwatchDeleteMsg:
      "Are you sure you want to delete this Stopwatch?",
    ConfirmActivityDelete: "Confirm Activity deletion",
    ConfirmActivityDeleteMsg: "Are you sure you want to delete this Activity?"
  },
  //Spanish LCID
  "3082": {
    ChildhoodObesityToolActvityTracker:
      "Herramienta para prevenir la obesidad infantil – Monitor de actividad",
    AddFamilyMember: "Añada otro miembro de la familia",
    About: "Sobre",
    EnterYourName: "Introduzca su nombre",
    TypeInTheNameOfAnActivity: "Escriba el nombre de la actividad",
    AddMoreActivities: "Añada más actividades",
    Activity: "Actividad",
    Duration: "Duración",
    Intensity: "Intensidad",
    Mins: "min",
    DeleteStopwatch:
      "Pulse aquí para borrar este cronómetro y todas las actividades",
    DeleteActivity: "Pulse aquí para borrar la actividad",
    Swimming: "Natación",
    Biking: "Ciclismo",
    Hiking: "Senderismo",
    Running: "Correr",
    Walking: "Caminar",
    BurningCalories: "Quemar calorías",
    Chess: "Ajedrez (jugar ajedrez)",
    Weights: "Pesas (ejercicio con pesas)",
    Basketball: "Baloncesto",
    Futbol: "Fútbol",
    FootballAmerican: "Fútbol americano",
    Volleyball: "Voleibol",
    PingPong: "Tenis de mesa",
    Beach: "la playa",
    Yes: "Si",
    No: "No",
    HighIntensity: "es-High Intensity",
    LowIntensity: "es-Low Intensity",
    ConfirmStopwatchDelete: "es-Confirm Stopwatch deletion",
    ConfirmStopwatchDeleteMsg:
      "es-Are you sure you want to delete this Stopwatch?",
    ConfirmActivityDelete: "es-Confirm Activity deletion",
    ConfirmActivityDeleteMsg:
      "es-Are you sure you want to delete this Activity?"
  }
};

// Get LCID from SharePoint.
let spLCID = window["_stopwatchContextInfo"]["localeLCID"];
let locStrings = new LocalizedStrings(langs);
// Set the lang.
locStrings.setLanguage(spLCID);

export let strings = { ...locStrings };
